import { render, staticRenderFns } from "./AppDocumentItem.vue?vue&type=template&id=85a46160&scoped=true&"
import script from "./AppDocumentItem.vue?vue&type=script&lang=js&"
export * from "./AppDocumentItem.vue?vue&type=script&lang=js&"
import style0 from "./AppDocumentItem.vue?vue&type=style&index=0&id=85a46160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a46160",
  null
  
)

export default component.exports